import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Modal from '../../../components/Modal'
import { Close } from '../../../assets/icons'
import { Button } from '../../../components/ui/button'
import useIsMobile from '../../../hooks/useIsMobile'
import theme from '../../../styled/theme'

function LogActionsFilterModal({ showModal, actions = [], selectedActions = [], onClose, onApply }) {
	const isMobile = useIsMobile()
	const [draftActions, setDraftActions] = useState(selectedActions)

	useEffect(() => {
		if (showModal) {
			setDraftActions(selectedActions)
		}
	}, [showModal, selectedActions])

	const handleToggleAction = actionKey => {
		setDraftActions(prev =>
			prev.includes(actionKey) ? prev.filter(item => item !== actionKey) : [...prev, actionKey]
		)
	}

	if (!showModal) return null

	return (
		<Modal isFullHeight={isMobile}>
			<FilterModalContainer isMobile={isMobile}>
				<FilterCloseButton type="button" onClick={onClose}>
					<Close color={theme.colors.brand.blueOmint} />
				</FilterCloseButton>
				<FilterBody>
					<FilterTitle>Filtros</FilterTitle>
					<FilterSubtitle>Filtrar por tipo de evento</FilterSubtitle>
					<FilterList>
						{actions.map(item => (
							<FilterItem key={item.key}>
								<ActionCheckbox
									type="checkbox"
									checked={draftActions.includes(item.key)}
									onChange={() => handleToggleAction(item.key)}
								/>
								<FilterItemLabel>{item.name}</FilterItemLabel>
							</FilterItem>
						))}
					</FilterList>
				</FilterBody>
				<FilterFooter>
					<Button
						label="Aplicar filtros"
						$variant="primary"
						size={isMobile ? 'mobile' : 'large'}
						onClick={() => onApply(draftActions)}
					/>
				</FilterFooter>
			</FilterModalContainer>
		</Modal>
	)
}

const FilterModalContainer = styled.div`
	width: 100%;
	background: ${props => props.theme.colors.brand.white};
	border-radius: ${props => (props.isMobile ? '24px 24px 0 0' : '24px')};
	padding: ${props => (props.isMobile ? '20px 20px 16px 20px' : '20px 24px 24px 24px')};
	max-width: ${props => (props.isMobile ? 'none' : '420px')};
	height: ${props => (props.isMobile ? '100%' : 'auto')};
	display: flex;
	flex-direction: column;
`

const FilterCloseButton = styled.button`
	border: none;
	background: transparent;
	padding: 0;
	margin-left: auto;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
`

const FilterBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 8px;
`

const FilterTitle = styled.h2`
	margin: 0;
	font-size: 36px;
	font-weight: 600;
	line-height: 1.2;
	color: ${props => props.theme.colors.text.primaryText};

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		font-size: 42px;
	}
`

const FilterSubtitle = styled.span`
	font-size: 18px;
	font-weight: 600;
	color: ${props => props.theme.colors.text.primaryText};
`

const FilterList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	max-height: 380px;
	overflow-y: auto;
`

const FilterItem = styled.label`
	display: flex;
	align-items: center;
	gap: 12px;
	cursor: pointer;
`

const ActionCheckbox = styled.input`
	width: 16px;
	height: 16px;
	margin: 0;
	accent-color: ${props => props.theme.colors.brand.blueOmint};
`

const FilterItemLabel = styled.span`
	font-size: 20px;
	line-height: 1.2;
	color: ${props => props.theme.colors.text.primaryText};
`

const FilterFooter = styled.div`
	margin-top: auto;
	padding-top: 24px;
	width: 100%;
	display: flex;
	justify-content: center;
`

export default LogActionsFilterModal
